import React from 'react'

import clsx from 'clsx'

import Button from 'components/Button'

import classes from './Tab.module.scss'

const Tab = ({ className, component, handleClick, icon, selected, label, ...rest }) => {
  return (
    <Button
      className={clsx(
        'Tab',
        classes.root,
        {
          [classes.selected]: selected,
        },
        className
      )}
      component={component}
      onClick={handleClick}
      aria-selected={selected}
      role="tab"
      {...rest}
    >
      <span className={classes.wrapper}>
        {icon && <span className={classes.icon}>{icon}</span>}
        {label}
      </span>
    </Button>
  )
}

export default Tab
